import {
  AI_PLATFORM_DUOMI,
  isOpenAiCompatibleImagePlatform,
  normalizeCatalogPlatformId,
} from '../constants/aiPlatforms'
import { buildGptImage2ImageOptions, isGptImage2ImagePlatform } from './gptImage2ImageOptions'
import { buildLingkeImageOptions, isLingkeAgiImagePlatform } from './lingkeImageOptions'
import { buildShiYunImageOptions } from './shiYunImageOptions'

export function buildImageCreationOptions(args: {
  platformId: string
  apiSize: string
  aspectOptions: readonly { value: string }[] | null | undefined
  aspectRatio: string
  extraParamValues: Record<string, string>
  /** 模型维度模式：决定 API 只发 size 还是只发 aspect_ratio */
  dimensionMode: 'size' | 'aspect_ratio'
}): Record<string, unknown> {
  const { platformId, apiSize, aspectRatio, extraParamValues, dimensionMode } = args
  if (isLingkeAgiImagePlatform(platformId)) {
    return buildLingkeImageOptions(apiSize, extraParamValues)
  }
  if (isGptImage2ImagePlatform(platformId)) {
    return buildGptImage2ImageOptions(platformId, apiSize, extraParamValues)
  }
  if (isOpenAiCompatibleImagePlatform(platformId)) {
    return buildShiYunImageOptions(apiSize, extraParamValues)
  }
  // 通用平台（Pidoi/Duomi/Siliconflow 等）：根据 dimensionMode 只发一个画幅参数
  const base: Record<string, unknown> = { ...extraParamValues }
  // extraParamValues.n 是 string，这里显式转 number 并 clamp，和 Lingke/ShiYun/GPT-Image-2 保持一致；
  // 缺失会导致上游按默认 1 张出图（用户选 3 张只回 1 张）。
  const nRaw = parseInt(extraParamValues.n ?? '1', 10)
  base.n = Number.isFinite(nRaw) ? Math.min(10, Math.max(1, nRaw)) : 1
  if (dimensionMode === 'aspect_ratio') {
    base.aspect_ratio = aspectRatio
  } else {
    base.size = apiSize
  }
  // flexible 仅 Duomi 上游消费（控制自动尺寸 + 竖图提示词后缀）；Pidoi/Siliconflow 上游忽略该键
  // （模型注册日志 ignored=[flexible, n]），按「没有的就不要传」不发送，避免误导排查。
  if (normalizeCatalogPlatformId(platformId) === AI_PLATFORM_DUOMI) {
    base.flexible = true
  }
  return base
}
